export default __webpack_public_path__ + "static/body-v2-07-waist-0a64ae47646df48059686bc4eed78bcd.png";